var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ApiCommandResource {
    constructor(common) {
        this.apiResource = common.apiResourceFactory("/api/asr/");
    }
    createOrganizationAvailableLanguage(languageCode, languageName, model, applicationId, providerType) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.create({
                languageCode,
                languageName,
                model,
                applicationId,
                providerType,
            }, {
                urlPostfix: "/language/create",
            });
            return response.organizationLanguageId;
        });
    }
    setTranslateProviderType(organizationLanguageId, applicationId, translateProviderType) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.update({
                organizationLanguageId,
                applicationId,
                translateProviderType,
            }, {
                urlPostfix: "/language/set",
            });
        });
    }
    removeOrganizationAvailableLanguage(organizationLanguageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.delete({
                urlPostfix: `/${organizationLanguageId}/language/remove`,
            });
        });
    }
    removeTranslateProvider(organizationLanguageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.delete({
                urlPostfix: `/${organizationLanguageId}/language/translate/remove`,
            });
        });
    }
    createUserTrancriptConfiguration(organizationLanguageId, applicationId, conferenceId, translate, record) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.create({
                organizationLanguageId,
                applicationId,
                conferenceId,
                translate,
                record,
            }, {
                urlPostfix: "/configuration",
            });
            return response;
        });
    }
    startTranslation(transcriptConfigurationId, languageCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.create({
                transcriptConfigurationId,
                languageCode,
            }, {
                urlPostfix: "/translation",
            });
            return response.transcriptId;
        });
    }
    cleanUserConfiguration(conferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.delete({
                urlPostfix: `/${conferenceId}/clean`,
            });
        });
    }
    stopTranslation() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.delete({
                urlPostfix: `/translation`,
            });
        });
    }
}
